import { gql } from "@apollo/client";

export const CREATE_AGENTS = gql`
mutation createAgent(
    $arcimedes_row_id: ID,
    $first_name: String,
    $last_name: String,
    $email: String,
    $phone: String,
    $cell_phone: String,  
    $firm: String,        
    $deleted: Int     
) {
    createOrUpdateAgent(input: {
        arcimedes_row_id: $arcimedes_row_id,
        first_name: $first_name,
        last_name: $last_name,
        email: $email,
        phone: $phone,
        cell_phone: $cell_phone,
        firm: $firm,
        deleted: $deleted
    }) {
        agent {
            arcimedes_row_id
            first_name
            last_name
            email
            phone
        }
    }
}
`


export const UPDATE_AGENT = gql`
mutation UpdateAgents($id: string!, $firstName: String!, $lastName: String!, $email: String!, $phone: string!){
    updateAgent(id: $id, firstName: $firstName, lastName: $lastName, email: $email, phone: $phone){
        id
        firstName
        lastName
        email
        phone
    }
}
`

//#region Drawer related mutations
export const CREATE_UPDATE_AGENT = gql`
mutation CreateOrUpdateAgent($input: AgentInput) {
  createOrUpdateAgent(input: $input) {
    success
    message
    agent {
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      deleted
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
`

export const CREATE_UPDATE_FIRM = gql`
mutation CreateOrUpdateFirm($input: FirmInput) {
  createOrUpdateFirm(input: $input) {
    firm {
      arcimedes_row_id
      name
      address
      city
      state
      zip
      phone
      parent_firm
      website
      deleted
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
    message
    success
  }
}
`

export const CREATE_UPDATE_LENDER = gql`
mutation CreateOrUpdateLenders($input: [LenderInput]!) {
  createOrUpdateLenders(input: $input) {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      NAME
      CITY
      STATE
      CONTACT_NAME
      CONTACT_PHONE
      CONTACT_EMAIL
      DELETED
      NOTES
    }
    error
  }
}
`
export const CREATE_UPDATE_BUYER = gql`
mutation CreateOrUpdateBuyer($input: BuyerInput) {
  createOrUpdateBuyer(input: $input) {
    success
    message
    buyer {
      arcimedes_row_id
      status
      agent
      agent_firm
      first_name
      last_name
      company_name
      company_address
      company_city
      company_state
      company_zip
      phone
      email
      notes
      profile
      category
      type
      single_tenant_subcategory
      multi_tenant_subcategory
      market
      price_min
      price_max
      cap_rate_min
      cap_rate_max
      strive_agent
      strive_agent_last_name
      cell_phone
      last_modified
      deleted
      hsc_follow_up
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
`

export const CREATE_UPDATE_SELLER_DRAWER = gql`
mutation CreateOrUpdateSellers($input: [SellerInput]!) {
  createOrUpdateSellers(input: $input) {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      STATUS
      AGENT
      FIRST_NAME
      LAST_NAME
      COMPANY_NAME
      COMPANY_ADDRESS
      COMPANY_CITY
      COMPANY_STATE
      COMPANY_ZIP
      PHONE
      EMAIL
      NOTES
      PROFILE
      CELL_PHONE
      LAST_MODIFIED
      DELETED
      ARCIMEDES_CREATED
      ARCIMEDES_CREATED_BY
      ARCIMEDES_MODIFIED
      ARCIMEDES_MODIFIED_BY
      first_name
      last_name
      phone
      email
      profile
      notes
      company_name
      company_address
      company_city
      company_state
      company_zip
    }
    error
  }
}
`
//#endregion